
export default [
  {
    path: '/admin/journal-entries',
    name: 'journal-entry',
    meta: { requiresAuth: true },
    component: () => import('@/pages/accounting/journal-entry')
  }
]
